const translation = {
    PageSize: 'Kích thước trang',
    PageOrientation: 'Loại trang',
    Format: 'Định dạng',
    DPI: 'Mật độ điểm ảnh (DPI)',
    Title: 'Xuất bản đồ',
    Close: 'Đóng',
    Save: 'Lưu',
    FileName: 'Tên tệp',
    Landscape: 'Ngang',
    Portrait: 'Dọc',
    PreviewHint: 'Điều chỉnh vùng cần xuất trên bản đồ.',
    ExportFailed: 'Xuất bản đồ thất bại. Vui lòng thử lại.',
    PreviewFailed: 'Không thể tạo bản xem trước.',
    AdjustArea: 'Điều chỉnh vùng trên bản đồ',
    AdjustAreaHint: 'Di chuyển, thu phóng, xoay hoặc nghiêng bản đồ để chọn vùng cần xuất',
    ZoomIn: 'Phóng to',
    ZoomOut: 'Thu nhỏ',
    ResetZoom: 'Đặt lại thu phóng về 100%',
    Done: 'Xong',
    Cancel: 'Hủy',
    Scalebar: 'Thanh tỷ lệ',
    NorthIcon: 'Biểu tượng hướng bắc',
    ChooseNorthIcon: 'Chọn biểu tượng hướng bắc',
    ChooseSvgFile: 'Chọn tệp SVG',
    IconSymbol: 'Ký hiệu',
    IconColor: 'Màu',
    IconSize: 'Kích thước',
    InvalidSvg: 'Tệp không phải là SVG hợp lệ.',
    ExportAsVector: 'Xuất dạng vector',
    ExportLabelsAsVector: 'Xuất nhãn dạng vector',
    Custom: 'Tùy chỉnh',
    Width: 'Chiều rộng',
    Height: 'Chiều cao',
    LanguageName: 'Tiếng Việt',
    LanguageCode: 'vi'
};
export default translation;
